// Bundle V2 - Gift Management (Reversed Backend Order)
(function() {
    'use strict';
    
    let originalGiftOrder = null; // Store original order once
    
    function storeOriginalOrder() {
        if (originalGiftOrder === null) {
            const giftItems = document.querySelectorAll('.gift-v2-item');
            originalGiftOrder = Array.from(giftItems);
        }
    }
    
    function updateGiftAvailability() {
        // Check both Bundle V2 and old bundle selections
        let selectedInput = document.querySelector('input[name="bundle-v2-selection"]:checked');
        let selectedVariant = null;
        
        // If Bundle V2 is selected, use that
        if (selectedInput) {
            selectedVariant = String(selectedInput.value);
        } else {
            // Otherwise, check old bundle selection
            const oldBundleInput = document.querySelector('input[name="bundle"]:checked');
            if (oldBundleInput) {
                selectedVariant = String(oldBundleInput.getAttribute('data-vid'));
            }
        }
        
        if (!selectedVariant) {
            console.log('No variant selected');
            return;
        }
        
        console.log('Selected variant ID:', selectedVariant);
        
        let hasAvailableGifts = false;
        
        // Store original order if not already stored
        storeOriginalOrder();
        
        // Process each gift item - add/remove disable class WITHOUT reordering
        originalGiftOrder.forEach(function(item) {
            const variants = item.getAttribute('data-variants');
            const itemId = item.getAttribute('id');
            
            if (variants) {
                const variantList = variants.split(',').map(v => String(v.trim()));
                const isAvailable = variantList.includes(selectedVariant);
                
                console.log('Gift:', itemId, 'Variants:', variantList, 'Available:', isAvailable);
                
                if (isAvailable) {
                    item.classList.remove('disable');
                    hasAvailableGifts = true;
                } else {
                    item.classList.add('disable');
                }
            } else {
                console.log('Gift:', itemId, 'has no data-variants attribute');
                item.classList.add('disable');
            }
        });
        
        console.log('Has available gifts:', hasAvailableGifts);
        
        // Update data-gift attribute for both bundle systems
        const allV2Inputs = document.querySelectorAll('input[name="bundle-v2-selection"]');
        allV2Inputs.forEach(input => input.setAttribute('data-gift', '0'));
        
        const allOldInputs = document.querySelectorAll('input[name="bundle"]');
        allOldInputs.forEach(input => input.setAttribute('data-gift', '0'));
        
        if (hasAvailableGifts) {
            // Set data-gift on the selected input
            if (selectedInput) {
                selectedInput.setAttribute('data-gift', '1');
                console.log('Set data-gift=1 on Bundle V2 input');
            }
            // Also update old bundle if it matches the variant
            allOldInputs.forEach(input => {
                if (String(input.getAttribute('data-vid')) === selectedVariant) {
                    input.setAttribute('data-gift', '1');
                }
            });
        }
        
        // Use CSS order property for reordering instead of DOM manipulation
        const container = document.querySelector('.gift-v2-items');
        if (container && originalGiftOrder.length > 0) {
            let availableOrder = 0;
            let disabledOrder = 1000; // Start disabled items at high order value
            
            originalGiftOrder.forEach(function(item, index) {
                if (item.classList.contains('disable')) {
                    // Disabled items go to the end, maintain their relative order
                    item.style.order = disabledOrder + index;
                } else {
                    // Available items go to the front, maintain their relative order
                    item.style.order = availableOrder + index;
                }
            });
        }
    }
    
    // Initialize Bundle V2
    function init() {
        console.log('Bundle V2 initializing...');
        
        const inputs = document.querySelectorAll('input[name="bundle-v2-selection"]');
        console.log('Found', inputs.length, 'bundle-v2 inputs');
        
        inputs.forEach(input => {
            input.addEventListener('change', function() {
                console.log('Bundle V2 selection changed to variant:', this.value);
                updateGiftAvailability();
                
                // Note: Price update is handled by bundle-subscription.js via the .bundle_item class
            });
        });
        
        // Listen for old bundle changes and sync with Bundle V2
        if (typeof $ !== 'undefined') {
            $(document).on('change', 'input[name="bundle"]', function() {
                // Sync Bundle V2 selection with old bundle
                const variantId = $(this).attr('data-vid');
                const v2Input = document.querySelector(`input[name="bundle-v2-selection"][value="${variantId}"]`);
                if (v2Input && !v2Input.checked) {
                    v2Input.checked = true;
                }
                updateGiftAvailability();
            });
        }
        
        // Initial update
        updateGiftAvailability();
    }
    
    // Expose functions globally
    window.bundleV2 = {
        init: init,
        updateGiftAvailability: updateGiftAvailability
    };

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', window.bundleV2.init);
    } else {
        window.bundleV2.init();
    }
})();